
    import * as React from 'react';

    const CarouselArrowMens60 = ({ color = 'currentcolor', height = '60px', width = '60px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 60 60" style={svgStyle}><g><path d="M31.977 23.707l.708-.707 7.122 7.124-7.122 7.123-.708-.707 5.916-5.916H21v-1h16.893z" /><path d="M0 60h60V0H0v60zm1-1V1h58v58H1z" /></g></svg>
        </div>
      );
    };

    CarouselArrowMens60.displayName = 'CarouselArrowMens60';

    export default CarouselArrowMens60;
  